import { render, staticRenderFns } from "./ReturnPartsRemarks.vue?vue&type=template&id=5233fbbc&scoped=true"
import script from "./ReturnPartsRemarks.vue?vue&type=script&lang=js"
export * from "./ReturnPartsRemarks.vue?vue&type=script&lang=js"
import style0 from "./ReturnPartsRemarks.vue?vue&type=style&index=0&id=5233fbbc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5233fbbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5233fbbc')) {
      api.createRecord('5233fbbc', component.options)
    } else {
      api.reload('5233fbbc', component.options)
    }
    module.hot.accept("./ReturnPartsRemarks.vue?vue&type=template&id=5233fbbc&scoped=true", function () {
      api.rerender('5233fbbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/returnparts/ReturnPartsRemarks.vue"
export default component.exports